import { render, staticRenderFns } from "./SimbarHeader.vue?vue&type=template&id=94b2402e&"
import script from "./SimbarHeader.vue?vue&type=script&lang=js&"
export * from "./SimbarHeader.vue?vue&type=script&lang=js&"
import style0 from "./SimbarHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports